import { Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { DropdownSubItem } from "../../../../ui/dropdown/DropdownSubItem";
import { ChipsList } from "./ChipsList";
import { DropdownItem } from "../../../../../types/apiTypes";
import { CustomChip } from "../../../../ui";
import { DropdownInput } from "../../../../ui/dropdown";

const ROW_LENGTH = 4;

type Props = {
  items: DropdownItem[];
  selected: DropdownItem[];
  setSelected: React.Dispatch<React.SetStateAction<DropdownItem[]>>;
  placeholder: string;
  withSelectAll?: boolean;
};

export const InputDropdown = ({
  items,
  selected,
  setSelected,
  placeholder,
  withSelectAll = true,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");

  const [internalSelected, setInternalSelected] =
    useState<DropdownItem[]>(selected);

  useEffect(() => {
    setInternalSelected(selected);
  }, [selected]);

  const cancelHandler = () => {
    setIsOpen(false);
    setSearch("");
    setInternalSelected(selected);
  };

  const submitHandler = () => {
    setIsOpen(false);
    setSearch("");
    setSelected(internalSelected);
  };

  const toogleItem = (sizeItem: DropdownItem) => {
    const existingItem = internalSelected.find(
      (item) => item.id === sizeItem.id,
    );

    if (existingItem) {
      setInternalSelected((prev) =>
        prev.filter((item) => item.id !== sizeItem.id),
      );
    } else {
      setInternalSelected((prev) => [...prev, sizeItem]);
    }
  };

  const removeItem = (id: string) => {
    const updated = selected.filter((item) => item.id !== id);

    setInternalSelected(updated);
    setSelected(updated);
  };

  const isSelected = (sizeItem: DropdownItem) =>
    internalSelected.some((item) => item.id === sizeItem.id);

  const filteredItems = items.filter((item) =>
    item.value.toLowerCase().includes(search.toLowerCase()),
  );

  const isSelectedAll = internalSelected.length === items.length;

  return (
    <Stack gap="8px">
      <DropdownInput
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        search={search}
        setSearch={setSearch}
        placeholder={placeholder}
        selectedCount={selected.length}
        submitHandler={submitHandler}
        cancelHandler={cancelHandler}
        closeHandler={cancelHandler}
        fullwidth
        showCounter={true}
      >
        {withSelectAll && (
          <DropdownSubItem
            title={"Select All"}
            checked={isSelectedAll}
            onClick={() => setInternalSelected(isSelectedAll ? [] : items)}
          />
        )}
        {filteredItems.map((item) => (
          <DropdownSubItem
            key={item.id}
            title={item.value}
            checked={isSelected(item)}
            onClick={() => toogleItem(item)}
          />
        ))}
      </DropdownInput>

      <ChipsList
        items={selected}
        rowLength={ROW_LENGTH}
        renderItem={({ id, value, isAdded }) => (
          <CustomChip
            key={id}
            label={value}
            onDelete={() => removeItem(id)}
            sx={{
              backgroundColor: isAdded ? "transparent" : "#E8ECF0",
              border: isAdded ? "1px solid #D2D8E2" : "none",
            }}
          />
        )}
      />
    </Stack>
  );
};
